module.exports = new Promise((resolve) => {
                    const src = 'https://kin-analytics-dataplor.web.app/remoteEntry.js';
                    const el = document.createElement('script');
                    el.src = src;
                    el.onload = () => resolve(window.DataplorAppMicro);
                    el.onerror = () => { console.warn('[MFE] DataplorAppMicro failed to load'); resolve({ get: () => Promise.resolve(() => () => null), init: () => {} }); };
                    document.head.appendChild(el);
                });